export const transformTag = (tag: string): string =>
  tag
    ?.trim()
    ?.toLowerCase()
    ?.replace(/\s+/g, "-")
    ?.replace(/[^a-z0-9!@#$%^&*()-=_+/,.~]+/g, "") ?? "";
